import { createContext } from 'react'

export type SearchPageContextType = true
const SearchPageContext = createContext<SearchPageContextType | undefined>(
  undefined,
)
export default SearchPageContext
